export var CurrencyCode;
(function (CurrencyCode) {
    CurrencyCode["AUD"] = "AUD";
    CurrencyCode["GBP"] = "GBP";
    CurrencyCode["CAD"] = "CAD";
    CurrencyCode["EUR"] = "EUR";
    CurrencyCode["HKD"] = "HKD";
    CurrencyCode["JPY"] = "JPY";
    CurrencyCode["NZD"] = "NZD";
    CurrencyCode["CHF"] = "CHF";
    CurrencyCode["USD"] = "USD";
    CurrencyCode["CNY"] = "CNY";
    CurrencyCode["AFN"] = "AFN";
    CurrencyCode["ALL"] = "ALL";
    CurrencyCode["DZD"] = "DZD";
    CurrencyCode["AOA"] = "AOA";
    CurrencyCode["ARS"] = "ARS";
    CurrencyCode["AMD"] = "AMD";
    CurrencyCode["AWG"] = "AWG";
    CurrencyCode["AZN"] = "AZN";
    CurrencyCode["BSD"] = "BSD";
    CurrencyCode["BHD"] = "BHD";
    CurrencyCode["BDT"] = "BDT";
    CurrencyCode["BBD"] = "BBD";
    CurrencyCode["BYN"] = "BYN";
    CurrencyCode["BZD"] = "BZD";
    CurrencyCode["BMD"] = "BMD";
    CurrencyCode["BTN"] = "BTN";
    CurrencyCode["BOB"] = "BOB";
    CurrencyCode["BAM"] = "BAM";
    CurrencyCode["BWP"] = "BWP";
    CurrencyCode["BRL"] = "BRL";
    CurrencyCode["BND"] = "BND";
    CurrencyCode["BGN"] = "BGN";
    CurrencyCode["MMK"] = "MMK";
    CurrencyCode["BIF"] = "BIF";
    CurrencyCode["KHR"] = "KHR";
    CurrencyCode["CVE"] = "CVE";
    CurrencyCode["KYD"] = "KYD";
    CurrencyCode["XAF"] = "XAF";
    CurrencyCode["XPF"] = "XPF";
    CurrencyCode["CLP"] = "CLP";
    CurrencyCode["COP"] = "COP";
    CurrencyCode["KMF"] = "KMF";
    CurrencyCode["CDF"] = "CDF";
    CurrencyCode["CRC"] = "CRC";
    CurrencyCode["CUP"] = "CUP";
    CurrencyCode["CZK"] = "CZK";
    CurrencyCode["DKK"] = "DKK";
    CurrencyCode["DJF"] = "DJF";
    CurrencyCode["DOP"] = "DOP";
    CurrencyCode["XCD"] = "XCD";
    CurrencyCode["EGP"] = "EGP";
    CurrencyCode["ERN"] = "ERN";
    CurrencyCode["ETB"] = "ETB";
    CurrencyCode["FKP"] = "FKP";
    CurrencyCode["FJD"] = "FJD";
    CurrencyCode["GMD"] = "GMD";
    CurrencyCode["GEL"] = "GEL";
    CurrencyCode["GHS"] = "GHS";
    CurrencyCode["GIP"] = "GIP";
    CurrencyCode["GTQ"] = "GTQ";
    CurrencyCode["GNF"] = "GNF";
    CurrencyCode["GYD"] = "GYD";
    CurrencyCode["HTG"] = "HTG";
    CurrencyCode["HNL"] = "HNL";
    CurrencyCode["HUF"] = "HUF";
    CurrencyCode["ISK"] = "ISK";
    CurrencyCode["INR"] = "INR";
    CurrencyCode["IDR"] = "IDR";
    CurrencyCode["IRR"] = "IRR";
    CurrencyCode["IQD"] = "IQD";
    CurrencyCode["ILS"] = "ILS";
    CurrencyCode["JMD"] = "JMD";
    CurrencyCode["JOD"] = "JOD";
    CurrencyCode["KZT"] = "KZT";
    CurrencyCode["KES"] = "KES";
    CurrencyCode["KWD"] = "KWD";
    CurrencyCode["KGS"] = "KGS";
    CurrencyCode["LAK"] = "LAK";
    CurrencyCode["LBP"] = "LBP";
    CurrencyCode["LSL"] = "LSL";
    CurrencyCode["LRD"] = "LRD";
    CurrencyCode["LYD"] = "LYD";
    CurrencyCode["MOP"] = "MOP";
    CurrencyCode["MKD"] = "MKD";
    CurrencyCode["MGA"] = "MGA";
    CurrencyCode["MWK"] = "MWK";
    CurrencyCode["MYR"] = "MYR";
    CurrencyCode["MVR"] = "MVR";
    CurrencyCode["MRU"] = "MRU";
    CurrencyCode["MUR"] = "MUR";
    CurrencyCode["MXN"] = "MXN";
    CurrencyCode["MDL"] = "MDL";
    CurrencyCode["MNT"] = "MNT";
    CurrencyCode["MAD"] = "MAD";
    CurrencyCode["MZN"] = "MZN";
    CurrencyCode["NAD"] = "NAD";
    CurrencyCode["NPR"] = "NPR";
    CurrencyCode["ANG"] = "ANG";
    CurrencyCode["TWD"] = "TWD";
    CurrencyCode["NIO"] = "NIO";
    CurrencyCode["NGN"] = "NGN";
    CurrencyCode["KPW"] = "KPW";
    CurrencyCode["NOK"] = "NOK";
    CurrencyCode["OMR"] = "OMR";
    CurrencyCode["PKR"] = "PKR";
    CurrencyCode["PAB"] = "PAB";
    CurrencyCode["PGK"] = "PGK";
    CurrencyCode["PYG"] = "PYG";
    CurrencyCode["PEN"] = "PEN";
    CurrencyCode["PHP"] = "PHP";
    CurrencyCode["PLN"] = "PLN";
    CurrencyCode["QAR"] = "QAR";
    CurrencyCode["RON"] = "RON";
    CurrencyCode["RUB"] = "RUB";
    CurrencyCode["RWF"] = "RWF";
    CurrencyCode["SHP"] = "SHP";
    CurrencyCode["WST"] = "WST";
    CurrencyCode["STN"] = "STN";
    CurrencyCode["SAR"] = "SAR";
    CurrencyCode["RSD"] = "RSD";
    CurrencyCode["SCR"] = "SCR";
    CurrencyCode["SLE"] = "SLE";
    CurrencyCode["SGD"] = "SGD";
    CurrencyCode["SBD"] = "SBD";
    CurrencyCode["SOS"] = "SOS";
    CurrencyCode["ZAR"] = "ZAR";
    CurrencyCode["KRW"] = "KRW";
    CurrencyCode["SSP"] = "SSP";
    CurrencyCode["LKR"] = "LKR";
    CurrencyCode["SDG"] = "SDG";
    CurrencyCode["SRD"] = "SRD";
    CurrencyCode["SZL"] = "SZL";
    CurrencyCode["SEK"] = "SEK";
    CurrencyCode["SYP"] = "SYP";
    CurrencyCode["TJS"] = "TJS";
    CurrencyCode["TZS"] = "TZS";
    CurrencyCode["THB"] = "THB";
    CurrencyCode["TOP"] = "TOP";
    CurrencyCode["TTD"] = "TTD";
    CurrencyCode["TND"] = "TND";
    CurrencyCode["TRY"] = "TRY";
    CurrencyCode["TMT"] = "TMT";
    CurrencyCode["UGX"] = "UGX";
    CurrencyCode["UAH"] = "UAH";
    CurrencyCode["AED"] = "AED";
    CurrencyCode["UYU"] = "UYU";
    CurrencyCode["UZS"] = "UZS";
    CurrencyCode["VUV"] = "VUV";
    CurrencyCode["VES"] = "VES";
    CurrencyCode["VND"] = "VND";
    CurrencyCode["XOF"] = "XOF";
    CurrencyCode["YER"] = "YER";
    CurrencyCode["ZMW"] = "ZMW";
    CurrencyCode["ZWG"] = "ZWG";
    CurrencyCode["ZWL"] = "ZWL";
})(CurrencyCode || (CurrencyCode = {}));
export var FxDataFeed;
(function (FxDataFeed) {
    FxDataFeed["CurrencyLayer"] = "CurrencyLayer";
})(FxDataFeed || (FxDataFeed = {}));
export var ForeignCurrencyCostRateCalculationType;
(function (ForeignCurrencyCostRateCalculationType) {
    ForeignCurrencyCostRateCalculationType["Average"] = "average cost";
})(ForeignCurrencyCostRateCalculationType || (ForeignCurrencyCostRateCalculationType = {}));
export var VehicleJurisdiction;
(function (VehicleJurisdiction) {
    VehicleJurisdiction["CaymanIslands"] = "Cayman Islands";
    VehicleJurisdiction["DelawareUS"] = "Delaware (US)";
    VehicleJurisdiction["EnglandUK"] = "England (UK)";
    VehicleJurisdiction["Guernsey"] = "Guernsey";
    VehicleJurisdiction["HongKong"] = "Hong Kong";
    VehicleJurisdiction["Ireland"] = "Ireland";
    VehicleJurisdiction["Jersey"] = "Jersey";
    VehicleJurisdiction["Luxembourg"] = "Luxembourg";
    VehicleJurisdiction["Scotland"] = "Scotland";
    VehicleJurisdiction["Singapore"] = "Singapore";
})(VehicleJurisdiction || (VehicleJurisdiction = {}));
export var ReportingPeriods;
(function (ReportingPeriods) {
    ReportingPeriods["Quarterly"] = "Quarterly";
    ReportingPeriods["HalfYearly"] = "HalfYearly";
})(ReportingPeriods || (ReportingPeriods = {}));
export var CommitmentType;
(function (CommitmentType) {
    CommitmentType["CapitalOnly"] = "CapitalOnly";
    CommitmentType["LoanOnly"] = "LoanOnly";
    CommitmentType["CapitalAndLoan"] = "CapitalAndLoan";
})(CommitmentType || (CommitmentType = {}));
export var CapitalContributionRule;
(function (CapitalContributionRule) {
    CapitalContributionRule["FixedCommitmentPercentage"] = "FixedCommitmentPercentage";
    CapitalContributionRule["ProRataOfFixedPartnershipCapital"] = "ProRataOfFixedPartnershipCapital";
    CapitalContributionRule["Manual"] = "Manual";
})(CapitalContributionRule || (CapitalContributionRule = {}));
//# sourceMappingURL=index.js.map